export function sanitizeHtml(input: string): string {
    if (!input) return input;
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');

    const allowedTags = new Set([
        'a', 'b', 'strong', 'i', 'em', 'u', 'p', 'br', 'ul', 'ol', 'li', 'span', 'div', 'img'
    ]);
    const allowedAttrs: Record<string, string[]> = {
        a: ['href', 'title', 'target', 'rel'],
        img: ['src', 'alt', 'title', 'width', 'height'],
        '*': ['title']
    };

    function isSafeUrl(val: string) {
        if (!val) return false;
        const v = val.trim().toLowerCase();
        if (/^(javascript|vbscript|data):/.test(v)) {
            // allow only data images
            return /^data:image\//.test(v);
        }
        return true;
    }

    function clean(node: Node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node as Element;
            const tag = el.tagName.toLowerCase();

            if (!allowedTags.has(tag)) {
                // unwrap element: move children before element, then remove it
                const parent = el.parentNode;
                if (parent) {
                    while (el.firstChild) parent.insertBefore(el.firstChild, el);
                    parent.removeChild(el);
                    return; // children will be processed via parent's loop
                }
            } else {
                // clean attributes
                for (const attr of Array.from(el.attributes)) {
                    const name = attr.name.toLowerCase();
                    const val = attr.value;
                    if (name.startsWith('on')) {
                        el.removeAttribute(attr.name);
                        continue;
                    }
                    const allowed = (allowedAttrs[tag] || []).concat(allowedAttrs['*'] || []);
                    if (!allowed.includes(name)) {
                        el.removeAttribute(attr.name);
                        continue;
                    }
                    if ((name === 'href' || name === 'src') && !isSafeUrl(val)) {
                        el.removeAttribute(attr.name);
                        continue;
                    }
                    if (name === 'rel' && el.getAttribute('target') === '_blank') {
                        el.setAttribute('rel', 'noopener noreferrer');
                    }
                }
            }
        }

        // recurse over a static list to avoid live collection issues
        for (const child of Array.from(node.childNodes)) clean(child);
    }

    Array.from(doc.body.childNodes).forEach(clean);
    return doc.body.innerHTML;
}
